import { SharingData } from '../../schema/SharingData';
import { isBefore, now } from 'owa-datetime';

export function isExpired(sharingData: SharingData): boolean {
    return (
        sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        isBefore(sharingData.sharingInfo.expirationDate, now())
    );
}
